import { useState, useRef } from "react";

const C = {
  white: "#FFFFFF",
  offWhite: "#F5F4F1",
  lightGray: "#E8E8E4",
  midGray: "#9CA3A0",
  darkGray: "#4A4A45",
  charcoal: "#2C2C28",
  deepTeal: "#1A1A16",
  green: "#2D5016",
  greenMid: "#3D6B1F",
  greenLight: "#4E7C2A",
  greenPale: "#EBF0E4",
  red: "#C0392B",
};

// TODO: set this to your deployed backend function URL.
// If you reuse the Base44 backend, paste the deployed URL here, e.g.
//   https://YOUR-APP.base44.app/api/functions/clientPortal
// Until set, uploads / admin login will fail with a connection error.
const API_BASE = "https://YOUR-APP.base44.app/api/functions/clientPortal";

function BrandMark({ size = 44, bg = C.charcoal }) {
  return (
    <div style={{ width: size, height: size, borderRadius: 4, backgroundColor: bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
      <svg width={size * 0.6} height={size * 0.6} viewBox="0 0 24 24" fill="none" stroke={C.greenLight} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 20c-1-7 3-12 10-13-1 8-4 13-10 13z" fill={C.greenLight} stroke={C.greenLight} />
        <path d="M11 20c1-4 3-6 7-8" stroke={C.charcoal} strokeWidth="1.2" fill="none" />
      </svg>
    </div>
  );
}

function Icon({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) {
  const icons = {
    lock: (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>),
    key: (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="15" r="5"/><line x1="21" y1="2" x2="11.5" y2="11.5"/><line x1="19" y1="4" x2="21" y2="6"/><line x1="15" y1="6" x2="17" y2="8"/></svg>),
    shield: (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>),
    check: (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>),
    upload: (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>),
    file: (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="13 2 13 9 20 9"/></svg>),
    inbox: (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg>),
    download: (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"><polyline points="8 17 12 21 16 17"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"/></svg>),
    refresh: (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>),
    chevron_down: (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>),
    chevron_right: (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>),
    x: (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>),
  };
  return icons[name] || null;
}

function Nav({ view, setView }) {
  return (
    <nav style={{
      backgroundColor: C.white, borderBottom: `1px solid ${C.lightGray}`,
      padding: "0 32px", display: "flex", alignItems: "center",
      justifyContent: "space-between", height: 72, flexWrap: "wrap", gap: 12,
    }}>
      <a href="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
        <BrandMark size={40} />
        <div>
          <div style={{ fontFamily: "Georgia, serif", fontSize: 15, fontWeight: 700, color: C.charcoal, letterSpacing: 0.5 }}>
            Build<span style={{ color: C.greenMid }}>Well</span> <span style={{ fontFamily: "sans-serif", fontSize: 13, letterSpacing: 1.5, fontWeight: 700 }}>HR CONSULTING</span>
          </div>
          <div style={{ fontSize: 11, fontFamily: "sans-serif", color: C.green, letterSpacing: 1, textTransform: "uppercase", marginTop: 2 }}>
            Secure Client Portal
          </div>
        </div>
      </a>
      <div style={{ display: "flex", gap: 12 }}>
        <button onClick={() => setView("client")} style={{
          backgroundColor: view === "client" ? C.green : "transparent",
          color: view === "client" ? C.white : C.charcoal,
          border: `1px solid ${view === "client" ? C.green : C.lightGray}`,
          padding: "8px 20px", fontSize: 12, fontFamily: "sans-serif",
          fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", cursor: "pointer",
        }}>Client Upload</button>
        <button onClick={() => setView("admin")} style={{
          backgroundColor: view === "admin" ? C.charcoal : "transparent",
          color: view === "admin" ? C.white : C.charcoal,
          border: `1px solid ${view === "admin" ? C.charcoal : C.lightGray}`,
          padding: "8px 20px", fontSize: 12, fontFamily: "sans-serif",
          fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", cursor: "pointer",
        }}>Laura's Login</button>
      </div>
    </nav>
  );
}

function ClientView() {
  const [step, setStep] = useState("code");
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState("");
  const [verifiedCode, setVerifiedCode] = useState("");
  const [form, setForm] = useState({ client_name: "", client_email: "", company: "", notes: "" });
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");
  const [uploadedCount, setUploadedCount] = useState(0);
  const fileRef = useRef();

  const verifyCode = async () => {
    setCodeError("");
    try {
      const res = await fetch(`${API_BASE}?action=verify_code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code }),
      });
      const data = await res.json();
      if (data.valid) {
        setVerifiedCode(code.trim().toUpperCase());
        setStep("upload");
      } else {
        setCodeError("Invalid access code. Please contact Laura for your code.");
      }
    } catch (e) {
      setCodeError("Connection error. The portal backend isn't configured yet — set API_BASE in ClientPortal.jsx.");
    }
  };

  const handleUpload = async () => {
    if (!form.client_name || !form.client_email) { setUploadError("Please fill in your name and email."); return; }
    if (files.length === 0) { setUploadError("Please select at least one file."); return; }
    setUploading(true); setUploadError(""); let count = 0;
    for (const file of files) {
      const fd = new FormData();
      fd.append("file", file); fd.append("access_code", verifiedCode);
      fd.append("client_name", form.client_name); fd.append("client_email", form.client_email);
      fd.append("company", form.company); fd.append("notes", form.notes);
      try {
        const res = await fetch(`${API_BASE}?action=upload`, { method: "POST", body: fd });
        const data = await res.json();
        if (data.success) count++; else setUploadError(`Failed to upload ${file.name}`);
      } catch (e) { setUploadError(`Error uploading ${file.name}`); }
    }
    setUploadedCount(count); setUploading(false);
    if (count > 0) setStep("done");
  };

  if (step === "code") {
    return (
      <div style={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 48, backgroundColor: C.offWhite }}>
        <div style={{ width: "100%", maxWidth: 460, backgroundColor: C.white, border: `1px solid ${C.lightGray}`, borderTop: `3px solid ${C.green}`, padding: 48 }}>
          <div style={{ width: 56, height: 56, borderRadius: 2, backgroundColor: C.greenPale, border: `1px solid ${C.lightGray}`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
            <Icon name="lock" size={26} color={C.green} strokeWidth={1.5} />
          </div>
          <h2 style={{ fontFamily: "Georgia, serif", fontSize: 26, fontWeight: 700, color: C.charcoal, marginBottom: 8 }}>Client Portal Access</h2>
          <p style={{ color: C.darkGray, fontSize: 14, fontFamily: "sans-serif", lineHeight: 1.7, marginBottom: 32 }}>
            Enter the access code provided by Laura to securely upload documents to your client folder.
          </p>
          <label style={{ color: C.darkGray, fontSize: 11, fontFamily: "sans-serif", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 6 }}>
            Access Code
          </label>
          <input
            type="text" placeholder="BWH-XXXXX-XXXX" value={code}
            onChange={e => setCode(e.target.value)}
            onKeyDown={e => e.key === "Enter" && verifyCode()}
            style={{ width: "100%", border: `1px solid ${C.lightGray}`, backgroundColor: C.offWhite, padding: "12px 16px", fontSize: 15, fontFamily: "sans-serif", color: C.charcoal, boxSizing: "border-box", outline: "none", letterSpacing: 2, textTransform: "uppercase", marginBottom: 8 }}
          />
          {codeError && <p style={{ color: C.red, fontSize: 13, fontFamily: "sans-serif", marginBottom: 16 }}>{codeError}</p>}
          <button onClick={verifyCode} style={{ width: "100%", backgroundColor: C.green, color: C.white, border: "none", padding: "14px", fontSize: 12, fontWeight: 700, fontFamily: "sans-serif", cursor: "pointer", letterSpacing: 1.5, textTransform: "uppercase", marginTop: 8 }}>Access Portal →</button>
          <p style={{ color: C.midGray, fontSize: 12, fontFamily: "sans-serif", textAlign: "center", marginTop: 20 }}>
            Don't have a code? Email <a href="mailto:hello@buildwellhr.com" style={{ color: C.green }}>Laura</a> to get access.
          </p>
        </div>
      </div>
    );
  }

  if (step === "done") {
    return (
      <div style={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 48, backgroundColor: C.offWhite }}>
        <div style={{ width: "100%", maxWidth: 460, backgroundColor: C.white, border: `1px solid ${C.green}`, padding: 48, textAlign: "center" }}>
          <div style={{ width: 64, height: 64, borderRadius: "50%", backgroundColor: C.greenPale, border: `2px solid ${C.green}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <Icon name="check" size={28} color={C.green} strokeWidth={2.5} />
          </div>
          <h2 style={{ fontFamily: "Georgia, serif", fontSize: 24, fontWeight: 700, color: C.charcoal, marginBottom: 10 }}>
            {uploadedCount} File{uploadedCount > 1 ? "s" : ""} Uploaded
          </h2>
          <p style={{ color: C.darkGray, fontFamily: "sans-serif", fontSize: 14, lineHeight: 1.7, marginBottom: 28 }}>
            Your documents have been securely uploaded to Laura's portal. She'll be in touch shortly.
          </p>
          <button onClick={() => { setStep("upload"); setFiles([]); setUploadedCount(0); }} style={{ backgroundColor: C.green, color: C.white, border: "none", padding: "12px 28px", fontSize: 12, fontWeight: 700, fontFamily: "sans-serif", cursor: "pointer", letterSpacing: 1, textTransform: "uppercase" }}>Upload More Files</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "80vh", backgroundColor: C.offWhite, padding: 48 }}>
      <div style={{ maxWidth: 680, margin: "0 auto" }}>
        <div style={{ backgroundColor: C.greenPale, border: `1px solid ${C.green}`, padding: "12px 20px", marginBottom: 32, display: "flex", alignItems: "center", gap: 10 }}>
          <Icon name="check" size={14} color={C.green} strokeWidth={2.5} />
          <span style={{ color: C.green, fontSize: 13, fontFamily: "sans-serif", fontWeight: 600 }}>Access code verified — you're in a secure session</span>
        </div>

        <div style={{ backgroundColor: C.white, border: `1px solid ${C.lightGray}`, borderTop: `3px solid ${C.green}`, padding: 40 }}>
          <h2 style={{ fontFamily: "Georgia, serif", fontSize: 24, fontWeight: 700, color: C.charcoal, marginBottom: 8 }}>Upload Documents</h2>
          <p style={{ color: C.darkGray, fontSize: 14, fontFamily: "sans-serif", marginBottom: 32, lineHeight: 1.7 }}>
            Your files are encrypted and only accessible to Laura. Upload any documents, PDFs, images, or spreadsheets.
          </p>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
            {[
              { key: "client_name", label: "Your Name *", placeholder: "Jane Smith" },
              { key: "client_email", label: "Your Email *", placeholder: "jane@company.com" },
              { key: "company", label: "Company", placeholder: "Acme Corp" },
            ].map(({ key, label, placeholder }) => (
              <div key={key} style={{ gridColumn: key === "company" ? "1 / -1" : undefined }}>
                <label style={{ color: C.darkGray, fontSize: 11, fontFamily: "sans-serif", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 6 }}>{label}</label>
                <input type="text" placeholder={placeholder} value={form[key]}
                  onChange={e => setForm({ ...form, [key]: e.target.value })}
                  style={{ width: "100%", border: `1px solid ${C.lightGray}`, backgroundColor: C.offWhite, padding: "11px 14px", fontSize: 14, fontFamily: "sans-serif", color: C.charcoal, boxSizing: "border-box", outline: "none" }} />
              </div>
            ))}
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ color: C.darkGray, fontSize: 11, fontFamily: "sans-serif", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Notes (optional)</label>
            <textarea rows={2} placeholder="Any context about these files..." value={form.notes}
              onChange={e => setForm({ ...form, notes: e.target.value })}
              style={{ width: "100%", border: `1px solid ${C.lightGray}`, backgroundColor: C.offWhite, padding: "11px 14px", fontSize: 14, fontFamily: "sans-serif", color: C.charcoal, boxSizing: "border-box", resize: "vertical", outline: "none" }} />
          </div>

          <div
            onClick={() => fileRef.current.click()}
            style={{ border: `2px dashed ${C.lightGray}`, backgroundColor: C.offWhite, padding: "36px 24px", textAlign: "center", cursor: "pointer", marginBottom: 12 }}
          >
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
              <Icon name="upload" size={32} color={C.midGray} strokeWidth={1.4} />
            </div>
            <p style={{ color: C.darkGray, fontSize: 14, fontFamily: "sans-serif", margin: 0 }}>
              Drag & drop files here, or <span style={{ color: C.green, fontWeight: 700 }}>click to browse</span>
            </p>
            <p style={{ color: C.midGray, fontSize: 12, fontFamily: "sans-serif", marginTop: 4 }}>PDF, Word, Excel, images, or any file type</p>
            <input ref={fileRef} type="file" multiple style={{ display: "none" }} onChange={e => setFiles(prev => [...prev, ...Array.from(e.target.files)])} />
          </div>

          {files.map((f, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 14px", backgroundColor: C.offWhite, border: `1px solid ${C.lightGray}`, marginBottom: 6 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Icon name="file" size={14} color={C.darkGray} strokeWidth={1.6} />
                <span style={{ fontSize: 13, fontFamily: "sans-serif", color: C.charcoal }}>{f.name}</span>
              </div>
              <button onClick={() => setFiles(files.filter((_, j) => j !== i))} style={{ background: "none", border: "none", color: C.midGray, cursor: "pointer", display: "flex", alignItems: "center", padding: 4 }}>
                <Icon name="x" size={14} color={C.red} strokeWidth={2} />
              </button>
            </div>
          ))}

          {uploadError && <p style={{ color: C.red, fontSize: 13, fontFamily: "sans-serif", marginBottom: 12 }}>{uploadError}</p>}

          <button onClick={handleUpload} disabled={uploading} style={{
            width: "100%", backgroundColor: uploading ? C.midGray : C.green,
            color: C.white, border: "none", padding: "15px",
            fontSize: 12, fontWeight: 700, fontFamily: "sans-serif",
            cursor: uploading ? "not-allowed" : "pointer",
            letterSpacing: 1.5, textTransform: "uppercase", marginTop: 8,
          }}>
            {uploading ? "Uploading securely..." : `Upload ${files.length > 0 ? files.length + " File" + (files.length > 1 ? "s" : "") : "Files"} →`}
          </button>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 10, justifyContent: "center", marginTop: 20 }}>
          <Icon name="shield" size={14} color={C.green} strokeWidth={1.6} />
          <span style={{ color: C.midGray, fontSize: 12, fontFamily: "sans-serif" }}>
            All files are encrypted and stored privately. Only Laura can access them.
          </span>
        </div>
      </div>
    </div>
  );
}

function AdminView() {
  const [step, setStep] = useState("login");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadingId, setDownloadingId] = useState(null);
  const [authedPassword, setAuthedPassword] = useState("");
  const [showArchived, setShowArchived] = useState(false);
  const [archivingClient, setArchivingClient] = useState(null);
  const [collapsedClients, setCollapsedClients] = useState({});

  const login = async () => {
    setLoginError("");
    try {
      const res = await fetch(`${API_BASE}?action=admin_login`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      const data = await res.json();
      if (data.valid) {
        setAuthedPassword(password); setStep("loading"); loadDocs(password);
      } else { setLoginError("Incorrect password."); }
    } catch (e) { setLoginError("Connection error. The portal backend isn't configured yet — set API_BASE in ClientPortal.jsx."); }
  };

  const loadDocs = async (pw) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}?action=get_documents`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: pw }),
      });
      const data = await res.json();
      setDocs(data.documents || []); setStep("docs");
    } catch (e) { setLoginError("Failed to load documents."); setStep("login"); }
    setLoading(false);
  };

  const download = async (doc) => {
    setDownloadingId(doc.id);
    try {
      const res = await fetch(`${API_BASE}?action=get_download_url`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: authedPassword, doc_id: doc.id }),
      });
      const data = await res.json();
      if (data.url) window.open(data.url, "_blank"); else alert("Could not get download link.");
    } catch (e) { alert("Failed to get download link."); }
    setDownloadingId(null);
  };

  const setClientArchived = async (clientName, archived) => {
    setArchivingClient(clientName);
    try {
      await fetch(`${API_BASE}?action=set_client_archived`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: authedPassword, client_name: clientName, archived }),
      });
      setDocs(prev => prev.map(d => d.client_name === clientName ? { ...d, archived } : d));
    } catch (e) { alert("Failed to update archive status."); }
    setArchivingClient(null);
  };

  const toggleCollapsed = (clientName) => {
    setCollapsedClients(prev => ({ ...prev, [clientName]: !prev[clientName] }));
  };

  if (step === "login") {
    return (
      <div style={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 48, backgroundColor: C.charcoal }}>
        <div style={{ width: "100%", maxWidth: 420, backgroundColor: C.white, borderTop: `3px solid ${C.charcoal}`, padding: 48 }}>
          <div style={{ width: 52, height: 52, borderRadius: 2, backgroundColor: C.offWhite, border: `1px solid ${C.lightGray}`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
            <Icon name="key" size={24} color={C.charcoal} strokeWidth={1.6} />
          </div>
          <h2 style={{ fontFamily: "Georgia, serif", fontSize: 24, fontWeight: 700, color: C.charcoal, marginBottom: 8 }}>Laura's Portal</h2>
          <p style={{ color: C.darkGray, fontSize: 14, fontFamily: "sans-serif", marginBottom: 28, lineHeight: 1.7 }}>
            Secure admin access. Only you have this password.
          </p>
          <label style={{ color: C.darkGray, fontSize: 11, fontFamily: "sans-serif", letterSpacing: 1, textTransform: "uppercase", display: "block", marginBottom: 6 }}>Password</label>
          <input type="password" placeholder="Enter your admin password" value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === "Enter" && login()}
            style={{ width: "100%", border: `1px solid ${C.lightGray}`, backgroundColor: C.offWhite, padding: "12px 16px", fontSize: 14, fontFamily: "sans-serif", color: C.charcoal, boxSizing: "border-box", outline: "none", marginBottom: 8 }} />
          {loginError && <p style={{ color: C.red, fontSize: 13, fontFamily: "sans-serif", marginBottom: 12 }}>{loginError}</p>}
          <button onClick={login} style={{ width: "100%", backgroundColor: C.charcoal, color: C.white, border: "none", padding: "14px", fontSize: 12, fontWeight: 700, fontFamily: "sans-serif", cursor: "pointer", letterSpacing: 1.5, textTransform: "uppercase", marginTop: 8 }}>Access Documents →</button>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: C.charcoal }}>
        <p style={{ color: C.white, fontFamily: "sans-serif" }}>Loading documents...</p>
      </div>
    );
  }

  const grouped = docs.reduce((acc, doc) => {
    const key = doc.client_name || "Unknown";
    if (!acc[key]) acc[key] = [];
    acc[key].push(doc);
    return acc;
  }, {});

  const activeClients = Object.entries(grouped).filter(([, clientDocs]) => !clientDocs[0]?.archived);
  const archivedClients = Object.entries(grouped).filter(([, clientDocs]) => clientDocs[0]?.archived);

  const renderClientCard = (clientName, clientDocs, isArchived) => {
    const isCollapsed = collapsedClients[clientName];
    const isArchiving = archivingClient === clientName;

    return (
      <div key={clientName} style={{
        backgroundColor: C.white, border: `1px solid ${C.lightGray}`,
        marginBottom: 16, borderTop: `3px solid ${isArchived ? C.midGray : C.green}`,
        opacity: isArchived ? 0.75 : 1,
      }}>
        <div style={{
          padding: "14px 24px", borderBottom: isCollapsed ? "none" : `1px solid ${C.lightGray}`,
          display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer",
        }} onClick={() => toggleCollapsed(clientName)}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <Icon name={isCollapsed ? "chevron_right" : "chevron_down"} size={14} color={C.midGray} strokeWidth={2} />
            <div>
              <div style={{ fontFamily: "Georgia, serif", fontSize: 16, fontWeight: 700, color: isArchived ? C.midGray : C.charcoal }}>
                {clientName}
                {isArchived && <span style={{ marginLeft: 8, fontSize: 11, fontFamily: "sans-serif", color: C.midGray, fontWeight: 400, textTransform: "uppercase", letterSpacing: 1 }}>Archived</span>}
              </div>
              <div style={{ fontSize: 12, fontFamily: "sans-serif", color: C.midGray }}>{clientDocs[0]?.client_email}{clientDocs[0]?.company ? ` · ${clientDocs[0].company}` : ""}</div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{
              backgroundColor: isArchived ? C.lightGray : C.greenPale,
              color: isArchived ? C.midGray : C.green,
              fontSize: 11, fontFamily: "sans-serif", padding: "3px 10px", fontWeight: 700,
            }}>{clientDocs.length} file{clientDocs.length !== 1 ? "s" : ""}</span>
            <button
              onClick={e => { e.stopPropagation(); setClientArchived(clientName, !isArchived); }}
              disabled={isArchiving}
              style={{ backgroundColor: "transparent", border: `1px solid ${C.lightGray}`, color: C.darkGray, padding: "4px 12px", fontSize: 11, fontFamily: "sans-serif", cursor: "pointer", letterSpacing: 0.5 }}
            >
              {isArchiving ? "..." : isArchived ? "Restore" : "Archive"}
            </button>
          </div>
        </div>

        {!isCollapsed && clientDocs.map((doc, i) => (
          <div key={doc.id} style={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            padding: "12px 24px",
            borderBottom: i < clientDocs.length - 1 ? `1px solid ${C.lightGray}` : "none",
            backgroundColor: i % 2 === 0 ? C.white : C.offWhite,
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <Icon name="file" size={14} color={C.midGray} strokeWidth={1.6} />
              <div>
                <div style={{ fontSize: 14, fontFamily: "sans-serif", color: C.charcoal, fontWeight: 500 }}>{doc.file_name}</div>
                <div style={{ fontSize: 11, fontFamily: "sans-serif", color: C.midGray, marginTop: 2 }}>
                  {doc.file_type && `${doc.file_type} · `}
                  {doc.created_date && new Date(doc.created_date).toLocaleDateString()}
                  {doc.notes && ` · ${doc.notes}`}
                </div>
              </div>
            </div>
            <button onClick={() => download(doc)} style={{
              backgroundColor: C.green, color: C.white, border: "none",
              padding: "7px 16px", fontSize: 11, fontWeight: 700,
              fontFamily: "sans-serif", cursor: "pointer", letterSpacing: 0.5,
              display: "flex", alignItems: "center", gap: 6,
            }}>
              <Icon name="download" size={12} color={C.white} strokeWidth={1.8} />
              {downloadingId === doc.id ? "..." : "Download"}
            </button>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div style={{ minHeight: "80vh", backgroundColor: C.offWhite, padding: 48 }}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 32 }}>
          <div>
            <h2 style={{ fontFamily: "Georgia, serif", fontSize: 28, fontWeight: 700, color: C.charcoal, marginBottom: 4 }}>Client Documents</h2>
            <p style={{ color: C.darkGray, fontFamily: "sans-serif", fontSize: 14 }}>
              {activeClients.length} active client{activeClients.length !== 1 ? "s" : ""}
              {archivedClients.length > 0 && ` · ${archivedClients.length} archived`}
            </p>
          </div>
          <button onClick={() => loadDocs(authedPassword)} style={{
            backgroundColor: C.green, color: C.white, border: "none",
            padding: "10px 20px", fontSize: 12, fontWeight: 700,
            fontFamily: "sans-serif", cursor: "pointer", letterSpacing: 1, textTransform: "uppercase",
            display: "flex", alignItems: "center", gap: 8,
          }}>
            <Icon name="refresh" size={13} color={C.white} strokeWidth={2} />
            Refresh
          </button>
        </div>

        {docs.length === 0 ? (
          <div style={{ backgroundColor: C.white, border: `1px solid ${C.lightGray}`, padding: 48, textAlign: "center" }}>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
              <Icon name="inbox" size={40} color={C.lightGray} strokeWidth={1.2} />
            </div>
            <p style={{ color: C.darkGray, fontFamily: "sans-serif", fontSize: 15 }}>No documents uploaded yet.</p>
          </div>
        ) : (
          <>
            {activeClients.length === 0 && (
              <div style={{ backgroundColor: C.white, border: `1px solid ${C.lightGray}`, padding: 24, textAlign: "center", marginBottom: 16 }}>
                <p style={{ color: C.midGray, fontFamily: "sans-serif", fontSize: 14 }}>No active clients — all are archived.</p>
              </div>
            )}
            {activeClients.map(([name, clientDocs]) => renderClientCard(name, clientDocs, false))}

            {archivedClients.length > 0 && (
              <div style={{ marginTop: 24 }}>
                <button
                  onClick={() => setShowArchived(!showArchived)}
                  style={{ background: "none", border: `1px solid ${C.lightGray}`, color: C.midGray, padding: "8px 18px", fontSize: 12, fontFamily: "sans-serif", cursor: "pointer", letterSpacing: 1, textTransform: "uppercase", marginBottom: 16, width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}
                >
                  <Icon name={showArchived ? "chevron_down" : "chevron_right"} size={12} color={C.midGray} strokeWidth={2} />
                  {showArchived ? "Hide" : "Show"} Archived Clients ({archivedClients.length})
                </button>
                {showArchived && archivedClients.map(([name, clientDocs]) => renderClientCard(name, clientDocs, true))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default function ClientPortal() {
  const [view, setView] = useState("client");
  return (
    <div style={{ minHeight: "100vh", backgroundColor: C.offWhite }}>
      <Nav view={view} setView={setView} />
      {view === "client" ? <ClientView /> : <AdminView />}
    </div>
  );
}
